import { render, staticRenderFns } from "./ServiceVisitBoardCard.vue?vue&type=template&id=b9117c52&scoped=true&"
import script from "./ServiceVisitBoardCard.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitBoardCard.vue?vue&type=style&index=0&id=b9117c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9117c52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
